class MapPreselectFilter extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.filterIndex = parseInt(this.dataset.filter, 10)
    this.containerFound = false

    this._formObserver = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(node => {
          if (node.matches?.(this.containerSelector)) {
            this.handleElement(node)
          } else if (node.querySelector?.(this.containerSelector)) {
            const container = node.querySelector(this.containerSelector)
            this.handleElement(container)
          }
        })
      }
    })

    this._formObserver.observe(this, { childList: true, subtree: true })

    const existingContainer = this.querySelector(this.containerSelector)
    if (existingContainer) this.handleElement(existingContainer)
  }

  handleElement (container) {
    if (this.containerFound) return
    this.containerFound = true

    // Stop observing once container is found
    if (this._formObserver) {
      this._formObserver.disconnect()
      delete this._formObserver
    }

    // Small timeout to ensure the container is fully rendered
    setTimeout(() => {
      const checkboxes = container.querySelectorAll(this.checkboxSelector)
      const checkboxToClick = checkboxes[this.filterIndex - 1]

      if (checkboxToClick) {
        checkboxToClick.click()
      }
    }, 2000)
  }

  get checkboxSelector () {
    return `input[name='filters']`
  }

  get containerSelector () {
    return `.stockist-search-filter-checkboxes`
  }
}

if (!customElements.get('map-preselect-filter')) {
  customElements.define('map-preselect-filter', MapPreselectFilter)
}
